export type PerformancePeriod = '7d' | 'month' | 'all';

export const PERFORMANCE_PERIODS: { id: PerformancePeriod; label: string }[] = [
  { id: '7d', label: 'Last 7 days' },
  { id: 'month', label: 'This month' },
  { id: 'all', label: 'All time' },
];

export interface PublicAgentProfile {
  id: string;
  fullName: string;
  jobTitle: string | null;
  city: string | null;
  bio: string | null;
  photoUrl: string | null;
  role: string;
  email?: string;
  signatureEmail?: string | null;
}

export interface AgentVisitStats {
  visits_today: number;
  visits_last_7_days: number;
  visits_this_month: number;
  visits_total: number;
  placements_secured_this_month: number;
  placements_secured_total: number;
}
